import {svgIconWrapper} from '../svg-icon-wrapper';

import InfoSquareRegular from './info-square-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <InfoSquareRegular {...validProps} />;
}

SvgComponent.iconName = 'infoSquareRegular';

export const InfoSquareRegularIcon = svgIconWrapper(SvgComponent);
